// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrganizationUrl_label__-0uID{
    display: block;
    color: #1F363D80;
    margin-left: 10px;
    margin-bottom: 8px;
    font-size: 14px;
    line-height: 14px;
}
.OrganizationUrl_urlRow__uasWl{
    display: flex;
    margin-left: 10px;
}
.OrganizationUrl_pencil__cOzwu, .OrganizationUrl_cancel__tdsct{
    position: relative;
    top: 1px;
    height: 15px;
    width: 15px;
    margin-right: 10px;
    cursor: pointer;
}
.OrganizationUrl_cancel__tdsct{
    position: relative;
    top: 4px;
    height: 12px;
    width: 12px;
    margin-right: 10px;
    cursor: pointer;
}
.OrganizationUrl_url__Od-9H{
    position: relative;
    margin-right: 15px;
    color: #1F363D;
    font-size: 16px;
    font-family: 'Gotham Medium', serif;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.OrganizationUrl_slug__bw-y-{
    width: 150px;
    color: #1F363D;
    font-size: 16px;
    font-family: 'Gotham Medium', serif;
    border-color: #1F363D;
    border-width: 0 0 2px 0;
    outline: none;
}
@media(max-width: 900px){
    .OrganizationUrl_urlPrefixFixedWidth__5A03d{
        display: inline-block;
        max-width: calc(100% - 160px);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .OrganizationUrl_slugContainer__AWDDy{
        position: relative;
        top: -4px;
    }
    .OrganizationUrl_slug__bw-y-{
        width: 140px;
    }
}
@media(min-width: 630px) and (max-width: 700px){
    .OrganizationUrl_slug__bw-y-{
        width: 150px;
    }
}
.OrganizationUrl_copy__PHUvp, .OrganizationUrl_copyStatus__otQQR, .OrganizationUrl_floppyDisk__L1ruU{
    margin-left: auto;
    cursor: pointer;
}
.OrganizationUrl_copy__PHUvp{
    height: 20px;
    width: 17px;
}
.OrganizationUrl_copyStatus__otQQR, .OrganizationUrl_saveStatus__U-l89{
    display: flex;
    position: relative;
    top: 4px;
}
.OrganizationUrl_copyStatusIcon__N53tk{
    height: 12px;
    width: 16px;
}
.OrganizationUrl_copyStatusText__\\+J8cz, .OrganizationUrl_saveStatusText__Ii0rz{
    margin-left: 5px;
    color: #40798C;
    font-size: 12px;
    font-family: 'Gotham Medium', serif;
}
.OrganizationUrl_floppyDisk__L1ruU{
    position: relative;
    top: 2px;
    height: 15px;
    width: 15px;
}
.OrganizationUrl_saveStatus__U-l89{
    margin-left: auto;
}
.OrganizationUrl_saveStatusIcon__Qn6jc{
    margin-left: auto;
    height: 12px;
    width: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/profile/OrganizationUrl.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,mCAAmC;IACnC,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,mCAAmC;IACnC,qBAAqB;IACrB,uBAAuB;IACvB,aAAa;AACjB;AACA;IACI;QACI,qBAAqB;QACrB,6BAA6B;QAC7B,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;IACpB;IACA;QACI,kBAAkB;QAClB,SAAS;IACb;IACA;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,QAAQ;AACZ;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,mCAAmC;AACvC;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,WAAW;AACf;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,WAAW;AACf","sourcesContent":[".label{\n    display: block;\n    color: #1F363D80;\n    margin-left: 10px;\n    margin-bottom: 8px;\n    font-size: 14px;\n    line-height: 14px;\n}\n.urlRow{\n    display: flex;\n    margin-left: 10px;\n}\n.pencil, .cancel{\n    position: relative;\n    top: 1px;\n    height: 15px;\n    width: 15px;\n    margin-right: 10px;\n    cursor: pointer;\n}\n.cancel{\n    position: relative;\n    top: 4px;\n    height: 12px;\n    width: 12px;\n    margin-right: 10px;\n    cursor: pointer;\n}\n.url{\n    position: relative;\n    margin-right: 15px;\n    color: #1F363D;\n    font-size: 16px;\n    font-family: 'Gotham Medium', serif;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n.slug{\n    width: 150px;\n    color: #1F363D;\n    font-size: 16px;\n    font-family: 'Gotham Medium', serif;\n    border-color: #1F363D;\n    border-width: 0 0 2px 0;\n    outline: none;\n}\n@media(max-width: 900px){\n    .urlPrefixFixedWidth{\n        display: inline-block;\n        max-width: calc(100% - 160px);\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        overflow: hidden;\n    }\n    .slugContainer{\n        position: relative;\n        top: -4px;\n    }\n    .slug{\n        width: 140px;\n    }\n}\n@media(min-width: 630px) and (max-width: 700px){\n    .slug{\n        width: 150px;\n    }\n}\n.copy, .copyStatus, .floppyDisk{\n    margin-left: auto;\n    cursor: pointer;\n}\n.copy{\n    height: 20px;\n    width: 17px;\n}\n.copyStatus, .saveStatus{\n    display: flex;\n    position: relative;\n    top: 4px;\n}\n.copyStatusIcon{\n    height: 12px;\n    width: 16px;\n}\n.copyStatusText, .saveStatusText{\n    margin-left: 5px;\n    color: #40798C;\n    font-size: 12px;\n    font-family: 'Gotham Medium', serif;\n}\n.floppyDisk{\n    position: relative;\n    top: 2px;\n    height: 15px;\n    width: 15px;\n}\n.saveStatus{\n    margin-left: auto;\n}\n.saveStatusIcon{\n    margin-left: auto;\n    height: 12px;\n    width: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `OrganizationUrl_label__-0uID`,
	"urlRow": `OrganizationUrl_urlRow__uasWl`,
	"pencil": `OrganizationUrl_pencil__cOzwu`,
	"cancel": `OrganizationUrl_cancel__tdsct`,
	"url": `OrganizationUrl_url__Od-9H`,
	"slug": `OrganizationUrl_slug__bw-y-`,
	"urlPrefixFixedWidth": `OrganizationUrl_urlPrefixFixedWidth__5A03d`,
	"slugContainer": `OrganizationUrl_slugContainer__AWDDy`,
	"copy": `OrganizationUrl_copy__PHUvp`,
	"copyStatus": `OrganizationUrl_copyStatus__otQQR`,
	"floppyDisk": `OrganizationUrl_floppyDisk__L1ruU`,
	"saveStatus": `OrganizationUrl_saveStatus__U-l89`,
	"copyStatusIcon": `OrganizationUrl_copyStatusIcon__N53tk`,
	"copyStatusText": `OrganizationUrl_copyStatusText__+J8cz`,
	"saveStatusText": `OrganizationUrl_saveStatusText__Ii0rz`,
	"saveStatusIcon": `OrganizationUrl_saveStatusIcon__Qn6jc`
};
export default ___CSS_LOADER_EXPORT___;
